import React, { useState } from "react";
import Logo from "../assets/logo.png";
import { useAppContext } from "../context/AppContext";
import LanguageToggler from "./LanguageToggler";
import { HeaderTrans, ToasterTrans } from "../utils/translations";
import LoginButton from "./LoginButton";
import { useLocation, useNavigate } from "react-router-dom";
import LoginModal from "./Login";
import { trackPixelEvent } from "../utils/pixel";
import CountryToggler from "./CountryToggler";

// Replace with standard React components for images and links
function Header() {
  const { language, toaster, setToaster, user, loading, premiumRoles, country } = useAppContext();
  const location = useLocation();
  const currentPath = location.pathname;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLoginClick = () => {
    setIsModalOpen(true); // Open modal on button click
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close modal
  };

  const handleRestrictedPageClick = () => {
    if (!user || !premiumRoles.includes(user?.role)) {
      //todo
      setToaster({ message: ToasterTrans[language].premium, type: "info", show: true })
    } else {
      navigate("/constructor");
    }
  }

  return (
    <>
      {/* desktop */}
      <div className={`hidden absolute lg:flex justify-between align-middle items-center px-20 w-screen z-10 text-sm font-medium top-0 bg-lightBeige h-10 border-b-[1px] ${(currentPath === "/constructor" || currentPath === "/shop" || currentPath === "/about") && "border-brown"}
`}>
        <a
          href="/landing"
          className="flex items-center gap-2 hover:pointer"
        >
          <img alt="logo" src={Logo} className="w-10 pb-1" />
          <span className="text-pink">
            {HeaderTrans[language].onceUp}{" "}
            <span className="text-black">
              {HeaderTrans[language].onMat}
            </span>
          </span>
        </a>
       {!loading && <div className="flex justify-between gap-5">
          <a href="/library" onClick={() => trackPixelEvent("NavigateToLibrary")} className="hover:text-pink cursor-pointer">{HeaderTrans[language].library}</a>
          {/* <a href="/offline" onClick={() => trackPixelEvent("NavigateToStudio")} className="hover:text-pink cursor-pointer">{HeaderTrans[language].studio}</a> */}
          {country === "IL" && <a href="/shop" onClick={() => trackPixelEvent("NavigateToShop")} className="hover:text-pink cursor-pointer">{HeaderTrans[language].shop}</a>}
          <a href="/blog" onClick={() => trackPixelEvent("NavigateToBlog")} className="hover:text-pink cursor-pointer">{HeaderTrans[language].blog}</a>
          {premiumRoles.includes(user?.role) && <a href="/live" onClick={() => trackPixelEvent("NavigateToLives")} className="hover:text-pink cursor-pointer">{HeaderTrans[language].lives}</a>}
          {premiumRoles.includes(user?.role) && <a href="/constructor" onClick={() => trackPixelEvent("NavigateToConstructor")} className="hover:text-pink cursor-pointer">{HeaderTrans[language].constructor}</a>}

          {/* // TODO uncomment when constructor and subcriptions work */}
          {/* <button onClick={() => { handleRestrictedPageClick(); trackPixelEvent("NavigateToConstructor") }} href="/constructor" className="hover:text-pink cursor-pointer">{HeaderTrans[language].constructor}</button> */}

          {/* <a href="/liveSessions" className="hover:text-pink cursor-pointer">{HeaderTrans[language].liveSessions}</a> */}
          {/* <a href="/blog" className="hover:text-pink cursor-pointer">{HeaderTrans[language].blog}</a> */}
        </div>}
        {!loading && <div className="flex gap-2">
          <LoginButton />
          <LanguageToggler />
          <CountryToggler />
        </div>}
      </div>
      {/* mobile */}
      <div className="lg:hidden absolute align-middle z-10 text-sm font-medium top-0 bg-white bg-opacity-70 w-screen pt-1 flex">
        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-2xl text-black mb-1 pl-4">
          ☰
        </button>
        <a
          href="/landing"
          className="flex items-center w-fit m-auto gap-2 hover:pointer"
        >
          <img alt="logo" src={Logo} className="w-9 pb-1" />
          <span className="text-pink">
            {HeaderTrans[language].onceUp}{" "}
            <span className="text-black">
              {HeaderTrans[language].onMat}
            </span>
          </span>
        </a>
        <div className="flex items-center gap-2 w-fit m-auto">
          <LanguageToggler />
          <LoginButton />
        </div>
      </div>
      {isMenuOpen && (
        <div className="bg-white bg-opacity-60 flex text-sm flex-col items-center text-black transition-all duration-300 pt-10">
          <a href="/library" onClick={() => trackPixelEvent("NavigateToLibrary")} className="py-2 hover:text-pink cursor-pointer">📚 {HeaderTrans[language].library}</a>
          {/* <a href="/offline" onClick={() => trackPixelEvent("NavigateToStudio")} className="py-2 hover:text-pink cursor-pointer">📅 {HeaderTrans[language].studio}</a> */}

          {country === "IL" && <a href="/shop" onClick={() => trackPixelEvent("NavigateToShop")} className="py-2 hover:text-pink cursor-pointer">🛍️ {HeaderTrans[language].shop}</a>}
          <a href="/blog" onClick={() => trackPixelEvent("NavigateToBlog")} className="py-2 hover:text-pink cursor-pointer">✍️ {HeaderTrans[language].blog}</a>

          {premiumRoles.includes(user?.role) && <a href="/live" onClick={() => trackPixelEvent("NavigateToLives")} className="py-2 hover:text-pink cursor-pointer">📽️ {HeaderTrans[language].lives}</a>}
          {premiumRoles.includes(user?.role) && <a href="/constructor" onClick={() => trackPixelEvent("NavigateToConstructor")} className="py-2 hover:text-pink cursor-pointer">💡 {HeaderTrans[language].constructor}</a>}
          <CountryToggler />
        </div>
      )}

      <LoginModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
}

export default Header;
